import {Button, Image} from 'antd'
import {LoginContext} from 'components/LoginContext'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import React, {useContext} from 'react'
import {nest, withProps} from 'recompose'
import {staticPaths} from 'routes/staticPaths'
import {ModuleLayoutWrapper} from 'views/AppLocals/factory/createModule'
import {AppHeader} from 'views/MainPage/MainHeader'
import {LoadingWrapper} from 'views/Shared'
import learnImage from 'assets/images/workspace_demo.png'

const WorkspaceLandingPage = () => {
    const t = useTranslate();

    const login = useContext(LoginContext)

    const InformationBloc = ({title, children}) => (
        <div className="flex flex-col gap-2 mt-4">
            <span className="font-semibold text-color-000 text-lg mt-2 md:mt-3">
                {title}
            </span>
            <div className="flex flex-col gap-1 ml-3">
                {children}
            </div>
        </div>
    )

    return (
        <LoadingWrapper
            timeout={500}
            isLoading={!login}>
            <div className="w-full h-full flex flex-col flex-center">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-center mx-6 mb-16">
                    <div className="flex flex-col">
                        <div className="flex flex-col gap-3 ml-0 md:ml-6">
                            <div className="font-bold text-color-000 text-2xl leading-tight">
                                {t('Kristo network helps Catholic organizations digitally transform')}
                            </div>
                            <span className="text-color-400 italic">
                {t('Catholic organizations here are understood as dioceses, parishes, associations, choirs, academies, religious orders, and other Christian groups')}
              </span>
                            <InformationBloc
                                title={t('there is a free content management system')}>
                <span className="text-sm text-color-400 italic">
                  {`- ${t(
                      'organizations can create and publish information in separate channel groups, such as blogs, research pages, reflections, and activity content'
                  )}`}
                </span>
                                <span className="text-sm text-color-400 italic">
                  {`- ${t(
                      'administrators can set up news channels as public or for internal use only'
                  )}`}
                </span>
                            </InformationBloc>
                            <InformationBloc
                                title={t('and many features to help manage the organization')}>
                <span className="text-sm text-color-400 italic">
                  {`- ${t('member administration')}`}
                </span>
                                <span className="text-sm text-color-400 italic">
                  {`- ${t('management of organizational events')}`}
                </span>
                                <span className="text-sm text-color-400 italic">
                  {`- ${t('link with relevant organizations')}`}
                </span>
                            </InformationBloc>
                        </div>
                        <NavigationContext.Consumer>
                            {({history, location}) =>
                                login ? (
                                    <div className="flex gap-4 mt-8 justify-end">
                                        <Button
                                            color="default" variant="filled"
                                            onClick={() => {
                                                const _searchParams = new URLSearchParams();
                                                _searchParams.set('type', 'organization')
                                                history.push(
                                                    {
                                                        ...location,
                                                        pathname: staticPaths.discovery.pathname,
                                                        search: '?' + _searchParams.toString(),
                                                    }
                                                )
                                            }}
                                            className="rounded-md no-text-shadow no-border bg-primary-50 hover:bg-primary-100 text-primary-600 hover:text-primary italic">
                                            {t('explore the community directory')}
                                        </Button>
                                    </div>
                                ) : (
                                    <div className="flex gap-4 mt-8 justify-end">
                                        <Button
                                            color="primary" variant="filled"
                                            onClick={() => {
                                                history.push(staticPaths.register)
                                            }}
                                            className="rounded-md no-text-shadow text-primary">
                                            {t('create account')}
                                        </Button>
                                        <Button
                                            color="primary" variant="solid"
                                            onClick={() => {
                                                history.push(staticPaths.login)
                                            }}
                                            className="rounded-md no-text-shadow no-border font-semibold">
                                            {t('login')}
                                        </Button>
                                    </div>
                                )
                            }
                        </NavigationContext.Consumer>
                    </div>
                    <div className="custom-image-landingpage">
                        <Image
                            preview={false}
                            src={learnImage}
                            wrapperClassName="w-full"
                            className="fadeIn animated object-cover"
                        />
                    </div>
                </div>
            </div>
        </LoadingWrapper>
    )
}

export default nest(
    withProps({
        Header: AppHeader,
    })(ModuleLayoutWrapper),
    WorkspaceLandingPage
)
